module.exports = __webpack_public_path__ + "images/batavus92ad98f5947ee7a54314cf93727a34ef.png";